import EmployeeInfo from "./EmployeeInfo";

export default EmployeeInfo;
